<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="`left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('이름')">
              <el-input v-model="searchForm.name" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('PasswordSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('PasswordAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PasswordUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PasswordDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('PasswordAdd') || checkAuthActionAccess('PasswordUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <el-table
          :height="tableHeight"
          ref="table"
          border
          stripe
          highlight-current-row
          tooltip-effect="dark"
          :data="tableData"
          :size="size"
          :empty-text="$t('데이타 없음')"
          @row-click="handleRowClick"
          @select="handleRowChecked">
          <el-table-column
            :label="tableData.length.toString()"
            type="index"
            width="55"
            align="center"
            sortable
            :fixed="!$device.mobile"
            label-class-name="data_cnt"></el-table-column>
          <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
          <el-table-column
            :label="$t('id')"
            prop="id"
            min-width="150"
            align="center"
            :fixed="!$device.mobile"></el-table-column>
          <el-table-column :label="$t('이름')" prop="name" min-width="150" sortable></el-table-column>
          <el-table-column
            :label="$t('타입')"
            prop="type.nm"
            min-width="110"
            align="center"
            show-overflow-tooltip></el-table-column>
          <!--					<el-table-column :label="$t('타입')" 	prop="type.nm" 	min-width="150" sortable></el-table-column>-->
        </el-table>
      </el-col>

      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('옵션') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('id')" v-if="'U' === inputForm.statu" required>
                <span>{{ inputForm.id }}</span>
              </el-form-item>
              <el-form-item :label="$t('이름')" :error="formError.name" required>
                <el-input v-model="inputForm.name" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('비밀번호')" :error="formError.password" required>
                <el-input v-model="inputForm.password" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('타입')" :error="formError.type" required>
                <code-combo :data="type" :model="inputForm.type" @change="inputForm.type = $event"></code-combo>
              </el-form-item>
            </el-form>
            <el-button
              v-if="checkAuthActionAccess('PasswordAdd') || checkAuthActionAccess('PasswordUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import mainVueMixin from '@/mixins/mainVueMixin'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/passwords'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    data.type = []

    return data
  },
  created: function () {
    this.search()
    this.initType()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.type': {
      handler: function (newVal) {
        if (newVal && 'I' === this.inputForm.statu) {
          this.existsType()
        }
      },
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        type: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        id: '',
        type: '',
        name: '',
        password: '',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        id: '',
        type: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].id
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.id,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('비밀번호 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      this.inputForm.typeVal = this.inputForm.type.val

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.id,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 타입 검증
    existsType: function () {
      const typeVal = this.inputForm.type && this.inputForm.type.val ? this.inputForm.type.val : this.inputForm.type
      if (!typeVal) {
        return
      }

      this.mainVue.$axios.patchNonLoading(
        this.url + '/' + typeVal + '/exists',
        null,
        null,
        function (result) {
          if (result.exists) {
            this.formError.id = this.$t('이미 사용중인 타입 타입ID입니다.')
            this.btn.saveDisabled = true
          } else {
            this.formError.id = ''
            this.btn.saveDisabled = false
          }
        }.bind(this),
        false
      )
    },
    // 타입
    initType: function () {
      this.mainVue.$axios.search(
        '/code/getCode/SYSTEM_PASSWORD_TP',
        null,
        function (result) {
          this.type = result
        }.bind(this),
        false
      )
    },
  },
}
</script>
